import { MARQUEE } from "../../data/content";

const Row = () => (
  <div className="flex shrink-0 items-center">
    {MARQUEE.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`font-display text-4xl sm:text-6xl tracking-tight px-8 ${i % 2 ? "italic text-[#D96B43]" : "text-[#F6F4EE]"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="h-5 w-5 text-[#7FA89C]" aria-hidden="true"><path d="M12 2v20M2 12h20" stroke="currentColor" strokeWidth="2" /></svg>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee-container" className="bg-[#0B2B26] py-10 sm:py-14 overflow-hidden" aria-label="Services">
    <div className="flex w-max marquee">
      <Row /><Row />
    </div>
  </section>
);
